import React, { useState, useEffect } from 'react';
import { Layout } from "@/components/Layout"
import { Toaster } from "@/components/ui/toaster"
import AccountDetailsPane from "@/components/AccountDetailsPane";
import {useParams} from "react-router-dom";

interface Account {
    storeUrl: string;
    expiresAt: string;
    hooksCount: number;
    usage: number;
}

export const AccountDetails: React.FC = () => {
    const {storeUrl} = useParams();
    const [activeMenuItem, setActiveMenuItem] = useState("trial-accounts")

    return (
        <Layout activeMenuItem={activeMenuItem} >
            <div className="space-y-6">
                <AccountDetailsPane storeUrl={storeUrl || ''} />
            </div>
            <Toaster />
        </Layout>
    )
};
